import { IApiRequestConfig } from '../api.types';
import { IUpdateUserSettingsData } from '../../resource/user-settings/user-settings.types';
import { IChangePasswordUserData } from '../../resource/user/user.types';

export const getUserSettingsApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getUserSettings',
  uri: 'json',
  action: 'self/settings',
  method: 'get',
  v2: true,
});

export const updateUserSettingsApi = (data: IUpdateUserSettingsData): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateUserSettings',
  uri: 'json',
  action: 'self/settings',
  method: 'patch',
  data: data,
  v2: true,
});

export const changePasswordUserSettingsApi = (
  password: IChangePasswordUserData['password'],
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'changePasswordUserSettings',
  uri: 'json',
  action: 'self/change-password',
  method: 'post',
  data: {
    password,
  },
  v2: true,
});
